// Generador de ids temporales (solo viven en memoria hasta persistir).
let counter = 0;

export function genId(prefix) {
  counter += 1;
  return prefix + "_" + counter + "_" + Math.random().toString(36).slice(2, 9);
}

// Un id con el formato de ObjectId de Mongo (12 bytes en hexa: 4 de timestamp + 8
// al azar). Los _id del árbol del torneo —rueda, zona, fecha, partido— los genera
// el cliente y no la base: los endpoints granulares direccionan por _id, así que
// una fecha o un partido recién creado tiene que poder nombrarse ante el backend
// sin esperar a que vuelva ningún guardado. `genId` sigue siendo el id de cliente,
// que se regenera en cada mapeo y no sirve para eso (ver torneoMapper.js).
export function nuevoObjectId() {
  const segundos = Math.floor(Date.now() / 1000).toString(16).padStart(8, "0");
  let azar = "";
  while (azar.length < 16) azar += Math.floor(Math.random() * 16).toString(16);
  return segundos + azar.slice(0, 16);
}
